import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { endpoint } from '..';
import Spinner from '../../../components/Spinner/Spinner';
import { IInitialState } from '../../../reduxService';
import { useAppDispatch, useAppSelector } from '../../../reduxService/hooks';
import { IProjectResultResponse } from '../../MACRA_1/api/IApiResponse';
import DischargeCurve from '../../MACRA_1/components/graphicalResults/dischargeCurve/DischargeCurve';
import { IProjectMacra1 } from '../../MACRA_1/store/project/projectSlice';
import { IProjectMacra2 } from '../../MACRA_2/store/project/projectSlice';
import { getActionByProjectType } from '../../actionMap';
import * as BeMaccaferriStoreHelper from '../../api/store/BeMaccaferriStoreHelper';
import { CanvasForExportImgs } from '../../components/Layout/Header/ExportButton/pdfjs';
import Layout from '../../components/Layout/Layout';
import { EProjectType } from '../../enum/project';
import { selectProjectInfo, setProjectInfo } from '../../store/projectInfo/projectInfoSlice';
import { selectUser } from '../../store/user/userSlice';
import { saveProject } from '../../utils/utils';
import './DesignCondition.scss';
import { IDesignConditionProps } from './IDesignCondition';

export const DesignConditionWithId = () => {
    const { id } = useParams();
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();

    const [isReady, setIsReady] = React.useState<boolean>(false);

    React.useEffect(() => {
        setIsReady(false);
        const getProject = async () => {
            let _id = parseInt(id!);
            let res = await BeMaccaferriStoreHelper.projectAvailableByAuthorAsync(_id, user.data!.email!);
            if (res.data) {
                let projectBase = await BeMaccaferriStoreHelper.getProjectBaseAsync(_id);
                let project: any;
                if (!!projectBase.data && projectBase.data.type === EProjectType.Macra1) {
                    project = await BeMaccaferriStoreHelper.getProjectCBPByIdAsync(projectBase.data.id!);
                } else project = await BeMaccaferriStoreHelper.getProjectGCSByIdAsync(projectBase.data.id!);
                const { setProject } = getActionByProjectType(project.projectInfo.type);
                dispatch(setProjectInfo(project.projectInfo!));
                dispatch(
                    setProject({
                        geometry: project.geometry,
                        hydraulicData: project.hydraulicData,
                        weirGeometry: project.weirGeometry,
                        wingsGeometry: project.wingsGeometry,
                        soilData: project.soilData,
                        stillingBasin: project.stillingBasin,
                    }),
                );
                setIsReady(true);
            }
        };
        getProject();
    }, [id]);

    return isReady ? <DesignCondition /> : <Spinner />;
};

export const DesignCondition = (props: IDesignConditionProps) => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);
    const [saved, setSaved] = React.useState(false);
    const [saveM2, setSaveM2] = React.useState(false);

    const { id } = useParams();

    if (projectInfo.initialState) {
        return <Navigate to={endpoint.home} replace={true} />;
    }

    const { selectResults, selectProject, inputForm, graphicalResults } = getActionByProjectType();

    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);
    const results: IInitialState<IProjectResultResponse> = useAppSelector(selectResults as any); //TODO aggiungi macra2

    const handleSaveCloud = async () => {
        let pInfo = projectInfo.data!;
        let idForSave = projectInfo.data?.id ? projectInfo.data.id : !!id ? parseInt(id) : undefined;
        await saveProject({ ...pInfo, id: idForSave }, true);
    };

    React.useEffect(() => {
        if (saved) {
            handleSaveCloud();
        }
    }, [saved]);

    React.useEffect(() => {
        if (!saved && !project.pending && !!project.data && !!project.data.geometry && !!project.data.hydraulicData) {
            setSaved(true);
        }
    }, [project.data, saved]);

    const hasRenderableProject = !!project.data && !!project.data.geometry && !!project.data.hydraulicData;
    const projectLoadFailed = !project.pending && !project.initialState && (!!project.error || !hasRenderableProject);

    return (
        <Layout>
            {project.pending || project.initialState ? (
                <Spinner />
            ) : projectLoadFailed ? (
                <div id='home' className='d-flex justify-content-center align-items-center h-100'>
                    <p className='fs-5'>{t('error_page_msg')}</p>
                </div>
            ) : (
                <div id='home' className='d-flex align-items-start gap-2 p-2 h-100'>
                    <div className='w-20 h-100 overflow-auto scroll'>{inputForm}</div>
                    <div className='w-80 results h-100'>{results.pending ? <Spinner /> : graphicalResults}</div>
                </div>
            )}
            <div style={{ height: '100%', width: '100%', position: 'relative', zIndex: '-1' }}>
                <DischargeCurve withSave />
            </div>
            <CanvasForExportImgs />
        </Layout>
    );
};
